import axios from "axios";
import { DataResponse, PaginatedResponse } from "models/common/responseObjects";
import { PriceGroup } from "models/dbModels/priceGroups/PriceGroup";
import { PriceGroupsSearchFilterQuery } from "models/filters/priceGroups/PriceGroupsSearchFilterQuery";

export class PriceGroupsApi {
    static Search = async (query: PriceGroupsSearchFilterQuery) => axios.post<PaginatedResponse<PriceGroup[]>>(`api/v1/PriceGroups/Search`, query);
    static Add = async (query: PriceGroup[]) => axios.post<DataResponse<number[]>>(`api/v1/PriceGroups/Add`, query);
    static Update = async (query: PriceGroup[]) => axios.post<DataResponse<boolean>>(`api/v1/PriceGroups/Update`, query);
    static Delete = async (query: PriceGroupsSearchFilterQuery) => axios.delete<DataResponse<boolean>>(`api/v1/PriceGroups/Delete`, { data: query });
}